import { applyMiddleware, compose, createStore } from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk'
import monitorReducersEnhancer from './enhancers/monitorReducer'
import loggerMiddleware from './middleware/logger'
import rootReducer from './reducers/reducer'

/**
 * This function contains the store's creation logic.
 * It applies the middlewares, the enhancers 
 * and create the store with initial state.
 * Returns store
 * @param {*} preloadedState 
 */
export default function configureStore(preloadedState) {
    const middlewares = [loggerMiddleware, thunkMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers = [middlewareEnhancer, monitorReducersEnhancer];
    const composedEnhancers = compose(...enhancers);

    const store = createStore(rootReducer, preloadedState, composedEnhancers);

    return store;
}